import { render, staticRenderFns } from "./renshi.vue?vue&type=template&id=4e2e2698&scoped=true"
import script from "./renshi.vue?vue&type=script&lang=js"
export * from "./renshi.vue?vue&type=script&lang=js"
import style0 from "./renshi.vue?vue&type=style&index=0&id=4e2e2698&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2e2698",
  null
  
)

export default component.exports